import { render } from "./addSeller.vue?vue&type=template&id=da1cd364&scoped=true"
import script from "./addSeller.vue?vue&type=script&lang=js"
export * from "./addSeller.vue?vue&type=script&lang=js"

import "./addSeller.vue?vue&type=style&index=0&id=da1cd364&lang=scss&scoped=true"

import exportComponent from "/root/qzf/src/invoice-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da1cd364"]])

export default __exports__